import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";

// Kept free of imports with load-time side effects (supported-services reads ConfigService at import),
// so store selectors can use the brand names without pulling app config in.
const INTEGRATION_SERVICE_NAMES: Record<IntegrationService, string> = {
  [IntegrationService.DYNAMICS]: "Microsoft Dynamics",
  [IntegrationService.HUBSPOT]: "HubSpot",
  [IntegrationService.NETSUITE]: "Netsuite",
  [IntegrationService.SALESFORCE]: "Salesforce",
  [IntegrationService.ZOHO]: "Zoho",
};

export const getIntegrationServiceName = (type?: null | string): string | undefined =>
  type && Object.prototype.hasOwnProperty.call(INTEGRATION_SERVICE_NAMES, type)
    ? INTEGRATION_SERVICE_NAMES[type as IntegrationService]
    : undefined;

export default INTEGRATION_SERVICE_NAMES;
